"use client";

import React from "react";
import { Linkedin, Twitter, Mail, Github } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const teamMembers = [{
  id: 1,
  name: "Γιώργος Παπαδόπουλος",
  role: "Lead Security Architect",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592747/img/team_george.png"
}, {
  id: 2,
  name: "Μαρία Κωνσταντίνου",
  role: "Network Operations Mgr",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592747/img/team_maria.png"
}, {
  id: 3,
  name: "Δημήτρης Νικολάου",
  role: "Systems Administrator",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592747/img/team_dimitris.png"
}, {
  id: 4,
  name: "Ελένη Γεωργίου",
  role: "Access Control Spec.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592747/img/team_eleni.png"
}];
const socialLinks = [{
  memberId: 1,
  platform: "linkedin",
  url: "#"
}, {
  memberId: 1,
  platform: "github",
  url: "#"
}, {
  memberId: 2,
  platform: "linkedin",
  url: "#"
}, {
  memberId: 2,
  platform: "twitter",
  url: "#"
}, {
  memberId: 3,
  platform: "linkedin",
  url: "#"
}, {
  memberId: 4,
  platform: "mail",
  url: "mailto:info@ds-services.gr"
}];
const getIcon = (platform: string) => {
  switch (platform) {
    case "linkedin":
      return <Linkedin className="size-4" />;
    case "twitter":
      return <Twitter className="size-4" />;
    case "github":
      return <Github className="size-4" />;
    case "mail":
      return <Mail className="size-4" />;
    default:
      return <Linkedin className="size-4" />;
  }
};
export default function TheTeamOfExperts() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="η-ομάδα-των-ειδικών" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-10" style={{
      backgroundImage: "radial-gradient(circle at 2px 2px, var(--color-primary) 1px, transparent 0)",
      backgroundSize: "32px 32px"
    }} />
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/20 to-transparent" />

      <div className="container mx-auto px-4 relative z-10">
        {}
        <div ref={headerRef} className={`text-center max-w-2xl mx-auto mb-16 transition-all duration-700 ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 font-mono tracking-tight">
            <span className="text-primary mr-2">&gt;</span>
            Η Ομάδα των Ειδικών
            <span className="animate-pulse text-primary ml-1">_</span>
          </h2>
          <p className="text-muted-foreground font-mono text-sm md:text-base">
            Εξειδικευμένο προσωπικό με πολυετή εμπειρία στην ασφάλεια δικτύων και την υποστήριξη υποδομών πληροφορικής για την <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592747/img/ds_services_logo.png" alt="Ds-Services" className="h-7 inline-block align-middle" />.
          </p>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 transition-all duration-1000 delay-200 ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {teamMembers.map((member, i) => <Card key={member.id} data-index={i} className="group p-0 overflow-hidden bg-card/40 backdrop-blur-md border-border/50 hover:border-primary/50 hover:shadow-[0_0_20px_-5px_var(--color-primary)] transition-all duration-500 rounded-xl relative flex flex-col">
              {}
              <div className="relative aspect-[3/4] overflow-hidden bg-muted/20">
                <img src={member.image} alt={member.name} className="w-full h-full object-cover object-center grayscale transition-all duration-700 group-hover:grayscale-0 group-hover:scale-105" />
                
                {}
                <div className="absolute inset-0 bg-primary/30 mix-blend-multiply transition-opacity duration-500 group-hover:opacity-0" />

                {}
                <div className="absolute inset-0 bg-[linear-gradient(transparent_50%,rgba(0,0,0,0.2)_50%)] bg-[length:100%_4px] pointer-events-none opacity-40 group-hover:opacity-10 transition-opacity duration-500" />

                {}
                <div className="absolute bottom-0 left-0 right-0 p-6 flex justify-center gap-3 bg-gradient-to-t from-background/95 via-background/80 to-transparent opacity-0 translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
                  {socialLinks.filter(s => s.memberId === member.id).map((social, idx) => <Button key={idx} data-index={idx} variant="outline" size="icon" className="size-9 rounded-full bg-background/50 backdrop-blur-md border-primary/30 hover:border-primary hover:bg-primary hover:text-primary-foreground transition-colors" asChild>
                        <Link to={social.url} newTab aria-label={`${social.platform} profile`}>
                          {getIcon(social.platform)}
                        </Link>
                      </Button>)}
                </div>
              </div>

              {}
              <div className="p-5 border-t border-border/30 relative bg-card/60 flex-grow flex flex-col justify-center">
                {}
                <div className="absolute top-0 right-0 w-3 h-3 border-t border-r border-primary/50 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute bottom-0 left-0 w-3 h-3 border-b border-l border-primary/50 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                <h3 className="font-mono text-base md:text-lg font-bold text-foreground mb-1 truncate">
                  {member.name}
                </h3>
                <p className="font-mono text-xs text-primary uppercase tracking-wider truncate">
                  {member.role}
                </p>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}